import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

function objFromArray(array, key = '_id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  error: null,
  mails: { byId: {}, allIds: [] },
  labels: [],
  page: 1,
  totalPages:1,
  totalDocs:0,
  cuenta:[]
};

const slice = createSlice({
  name: 'mail',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET LABELS
    getLabelsSuccess(state, action) {
      state.isLoading = false;
      state.labels = action.payload;
    },

    // GET MAILS
    getMailsSuccess(state, action) {
      const mails = action.payload[0].docs;
      console.log("engetmails", action.payload)
      console.log("engetmails", mails)


      state.page = action.payload[0].page
      state.totalPages = action.payload[0].totalPages
      state.totalDocs = action.payload[0].totalDocs
      state.cuenta=action.payload[0].cuenta
      
      state.isLoading = false;
      state.mails.byId = objFromArray(mails);
      
      state.mails.allIds = Object.keys(state.mails.byId);
    },

    nextPage(state){
      state.page = 2
    },

    // GET MAIL
    getMailSuccess(state, action) {
      const mail = action.payload;
      console.log("aaa.....a", mail)
      state.mails.byId[mail._id] = mail;
      if (!state.mails.allIds.includes(mail._id)) {
        state.mails.allIds.push(mail._id);
      }
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getLabels(cargo) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const criterios = await axios.get('/api/memos/memos/labels', {params:{cargo}});
      console.log("criterios", criterios.data)
      dispatch(slice.actions.getLabelsSuccess(criterios.data.labels));
    } catch (error) {
      const response = {"labels":[{"id":"all","type":"system","name":"Todos","unreadCount":null},{"id":"inbox","type":"system","name":"Recibidos","unreadCount":null},{"id":"id_distribucion","type":"system","name":"Por Distribución","unreadCount":null,"color":"#1890FF"},{"id":"sent","type":"system","name":"enviados","unreadCount":null},{"id":"id_derivado","type":"system","name":"derivados","unreadCount":null,"color":"#00AB55"},{"id":"id_revision","type":"system","name":"Por revisión","unreadCount":null,"color":"#FFC107"}]}
      dispatch(slice.actions.getLabelsSuccess(response.labels));
      // dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getMails(params, depto, page, buscado) {
  return async () => {
    dispatch(slice.actions.startLoading());
    console.log("dentro de getMail", params.systemLabel, depto)
    try {
      const response3 = await axios.get('/api/memos/memos/dos', {params:{systemLabel:params.systemLabel, departamento:depto, pagina:page, buscado}});
      console.log("respuesta a consulta", response3);
      // const response ={"mails":[{"id":"e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1","labelIds":["id_promotions","id_distribucion", "drafts"],"folder":"spam","isImportant":true,"isStarred":true,"isUnread":true,"subject":"Apply These 7 Secret Techniques To Improve Event","message":"Assumenda nam repudiandae rerum fugiat vel maxime.","createdAt":"2022-03-28T15:07:07.910Z","files":[],"from":{"name":"Jayvion Simon","email":"nannie_abernathy70@yahoo.com","avatar":"https://minimal-assets-api.vercel.app/assets/images/avatars/avatar_1.jpg"},"to":[{"name":"Jaydon Frankie","email":"demo@minimals.cc","avatar":null}]},{"id":"e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2","labelIds":["id_forums"],"folder":"spam","isImportant":true,"isStarred":true,"isUnread":true,"subject":"Believing These 7 Myths About Event Keeps You From Growing","message":"Quis veniam aut saepe aliquid nulla.","createdAt":"2022-03-27T14:07:07.910Z","files":["https://minimal-assets-api.vercel.app/assets/images/feeds/feed_2.jpg","https://minimal-assets-api.vercel.app/assets/images/feeds/feed_3.jpg"],"from":{"name":"Lucian Obrien","email":"ashlynn_ohara62@gmail.com","avatar":null},"to":[{"name":"Jaydon Frankie","email":"demo@minimals.cc","avatar":null}]},{"id":"e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3","labelIds":[],"folder":"folder","isImportant":true,"isStarred":true,"isUnread":true,"subject":"Don't Waste Time! 7 Facts Until You Reach Your Event","message":"Reprehenderit ut voluptas sapiente ratione nostrum est.","createdAt":"2022-03-26T13:07:07.910Z","files":["https://mail.google.com/mail/u/file1.docx","https://mail.google.com/mail/u/file2.xlsx","https://mail.google.com/mail/u/file3.pptx","https://mail.google.com/mail/u/file7.sketch"],"from":{"name":"Deja Brady","email":"milo.farrell@hotmail.com","avatar":null},"to":[{"name":"Jaydon Frankie","email":"demo@minimals.cc","avatar":null}]},{"id":"e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4","labelIds":[],"folder":"promotions","isImportant":false,"isStarred":false,"isUnread":false,"subject":"How 7 Things Will Change The Way You Approach Event","message":"Error ut sit vel molestias velit.","createdAt":"2022-03-25T12:07:07.910Z","files":[],"from":{"name":"Harrison Stein","email":"violet.ratke86@yahoo.com","avatar":"https://minimal-assets-api.vercel.app/assets/images/avatars/avatar_4.jpg"},"to":[{"name":"Jaydon Frankie","email":"demo@minimals.cc","avatar":null}]},{"id":"e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5","labelIds":["id_derivado"],"folder":"folder","isImportant":false,"isStarred":false,"isUnread":false,"subject":"Event Awards: 7 Reasons Why They Don't Work & What You Can Do About It","message":"Quo quia sit nihil nemo doloremque et.","createdAt":"2022-03-24T11:07:07.910Z","files":[],"from":{"name":"Reece Chung","email":"letha_lubowitz24@yahoo.com","avatar":"https://minimal-assets-api.vercel.app/assets/images/avatars/avatar_5.jpg"},"to":[{"name":"Jaydon Frankie","email":"demo@minimals.cc","avatar":null}]},{"id":"e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6","labelIds":[],"folder":"inbox","isImportant":true,"isStarred":true,"isUnread":true,"subject":"Event Doesn't Have To Be Hard. Read These 7 Tips","message":"Autem doloribus harum vero laborum.","createdAt":"2022-03-23T10:07:07.910Z","files":["https://minimal-assets-api.vercel.app/assets/images/feeds/feed_2.jpg","https://minimal-assets-api.vercel.app/assets/images/feeds/feed_3.jpg","https://minimal-assets-api.vercel.app/assets/images/avatars/avatar_12.mp4","https://mail.google.com/mail/u/file1.docx","https://mail.google.com/mail/u/file2.xlsx","https://mail.google.com/mail/u/file3.pptx","https://mail.google.com/mail/u/file4.pdf","https://mail.google.com/mail/u/file5.psd","https://mail.google.com/mail/u/file6.esp","https://mail.google.com/mail/u/file7.sketch"],"from":{"name":"Lainey Davidson","email":"aditya_greenfelder31@gmail.com","avatar":null},"to":[{"name":"Jaydon Frankie","email":"demo@minimals.cc","avatar":null}]},{"id":"e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7","labelIds":[],"folder":"promotions","isImportant":false,"isStarred":false,"isUnread":false,"subject":"Event Is Your Worst Enemy. 7 Ways To Defeat It","message":"Tempora officiis consequuntur architecto nostrum autem nam adipisci.","createdAt":"2022-03-22T09:07:07.910Z","files":[],"from":{"name":"Cristopher Cardenas","email":"lenna_bergnaum27@hotmail.com","avatar":null},"to":[{"name":"Jaydon Frankie","email":"demo@minimals.cc","avatar":null}]},{"id":"e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8","labelIds":[],"folder":"inbox","isImportant":false,"isStarred":false,"isUnread":false,"subject":"Event On A Budget: 7 Tips From The Great Depression","message":"Voluptas sunt magni adipisci praesentium saepe.","createdAt":"2022-03-21T08:07:07.910Z","files":[],"from":{"name":"Melanie Noble","email":"luella.ryan33@gmail.com","avatar":"https://minimal-assets-api.vercel.app/assets/images/avatars/avatar_8.jpg"},"to":[{"name":"Jaydon Frankie","email":"demo@minimals.cc","avatar":null}]},{"id":"e99f09a7-dd88-49d5-b1c8-1daf80c2d7b9","labelIds":[],"folder":"promotions","isImportant":false,"isStarred":false,"isUnread":false,"subject":"Knowing These 7 Secrets Will Make Your Event Look Amazing","message":"Ea architecto quas voluptates voluptas earum illo est vel rem.","createdAt":"2022-03-20T07:07:07.910Z","files":[],"from":{"name":"Chase Day","email":"joana.simonis84@gmail.com","avatar":null},"to":[{"name":"Jaydon Frankie","email":"demo@minimals.cc","avatar":null}]}]}

      dispatch(slice.actions.getMailsSuccess([response3.data]));
      // dispatch(slice.actions.getMailsSuccess(response.data.mails));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getMail(memoId, depto) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/registro/memos/ver/', {
        params: { memoId, depto },
      });
      dispatch(slice.actions.getMailSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
